import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { BfxVwapOrdersService } from "./bfx-vwap-orders.service";
import { BfxVwapTradeService } from "./bfx-vwap-trade.service";

import { BfxVwapTooltipOrdersComponent } from "./bfx-vwap-tooltip-orders.component";
import { BfxVwapTooltipTradeComponent } from "./bfx-vwap-tooltip-trade.component";
import { BfxVwapTooltipComponent } from "./bfx-vwap-tooltip.component";

import { BfxVwapRatePipe } from "./pipes/bfx-vwap-rate.pipe";
import { BfxVwapAmountPipe } from "./pipes/bfx-vwap-amount.pipe";

//perfect scrollbar
import { PerfectScrollbarModule } from "@bfx/ngx-perfect-scrollbar";
import { PerfectScrollbarConfigInterface } from "@bfx/ngx-perfect-scrollbar";
import { PERFECT_SCROLLBAR_CONFIG } from "@bfx/ngx-perfect-scrollbar";
import { FlexLayoutModule } from "@angular/flex-layout";
import { BfxVwapInfo } from "./bfx-vwap-info";

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
};

@NgModule({
  declarations: [
    BfxVwapTooltipOrdersComponent,
    BfxVwapTooltipTradeComponent,
    BfxVwapTooltipComponent,
    BfxVwapRatePipe,
    BfxVwapAmountPipe,
  ],
  imports: [
    CommonModule,
    FormsModule,
    PerfectScrollbarModule, //PERFECT_SCROLLBAR_CONFIG,
    FlexLayoutModule,
  ],
  exports: [BfxVwapTooltipOrdersComponent, BfxVwapTooltipTradeComponent, BfxVwapTooltipComponent],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
    BfxVwapOrdersService,
    BfxVwapTradeService,
    BfxVwapInfo,
  ],
})
export class BfxVwapModule {}
